//Import required modules
import * as d3 from 'd3';

const customColorArr = [
    ['#900C00', '#EF9A9A'],
    ['#FFEB3B', '#FFF9C4'],
    ['#33691E', '#C5E1A5'],
    ['#08306B', '#82BBDB'],
    ['#E65100', '#FFE0B2'],
    ['#4A148C', '#CE93D8'],
    ['#212121', '#FAFAFA'],
    ['#3E2723', '#BCAAA4'],
    ['#880E4F', '#F8BBD0'],
    ['#006064', '#B2EBF2'],
    ['#004D40', '#B2DFDB'],
    ['#827717', '#E6EE9C'],
    ['#01579B', '#B3E5FC'],
    ['#1B5E20', '#A5D6A7'],
    ['#263238', '#ECEFF1'],//bluegray
    ['#1A237E', '#9FA8DA']//indigo
    ]


const colorFunc = 
{
"arrNative":[

            d3.interpolateSinebow,
            d3.interpolateRainbow,
            d3.interpolateTurbo,
            d3.interpolateViridis,    
            d3.interpolatePlasma,
            d3.interpolateCividis,
            d3.interpolateWarm,
            d3.interpolateCool,

            d3.interpolateInferno,
            d3.interpolateMagma,
            d3.interpolateBlues,
            d3.interpolateGreens,
            d3.interpolateGreys,
            d3.interpolateOranges,
            d3.interpolatePurples,
            d3.interpolateReds,
            d3.interpolateCubehelixDefault,
            d3.interpolateBrBG,
            d3.interpolatePRGn,
            d3.interpolatePiYG,
            d3.interpolatePuOr,
            d3.interpolateRdBu,
            d3.interpolateRdGy,
            d3.interpolateRdYlBu,
            d3.interpolateRdYlGn,
            d3.interpolateSpectral,
            d3.interpolateBuGn,
            d3.interpolateBuPu,
            d3.interpolateGnBu,
            d3.interpolateOrRd,
            d3.interpolatePuBuGn,
            d3.interpolatePuBu,
            d3.interpolatePuRd,
            d3.interpolateRdPu,
            d3.interpolateYlGnBu,
            d3.interpolateYlGn,
            d3.interpolateYlOrBr,
            d3.interpolateYlOrRd
],
"arrCustom": customColorArr.map(d => d3.interpolate(d[1], d[0]))
};

const colorFuncAll = [...colorFunc['arrCustom'], ...colorFunc['arrNative']]    

export { colorFuncAll }